var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-4 col-sm-6 dashboard-item"},[_c('div',{staticClass:"card bg"},[_c('div',{staticClass:"text-primary pt-4 pb-4"},[(_vm.tutorials)?_c('tutorial',{attrs:{"tutorials":_vm.tutorials}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }